import CityPagePersianas from "../components/CityPagePersianas";

export default function PersianasBenahavis() {
  return (
    <CityPagePersianas
      name="Benahavís"
      slug="benahavis"
      cp="29679"
      poblacion={9000}
      zonaGeo="Costa del Sol Occidental"
      lat={36.5197}
      lng={-5.0428}
      zonas={[
        "Centro Pueblo",
        "La Zagaleta",
        "El Madroñal",
        "Los Arqueros",
        "Marbella Club Golf Resort",
      ]}
      landmarks={[
        "Plaza Pueblo",
        "La Zagaleta",
        "Mirador Daidín",
      ]}
      municipiosLimitrofes={[
        "Marbella",
        "Estepona",
        "Ronda",
      ]}
      festivalLocal="Feria de Benahavís, mediados de agosto"
      contextoTipologico="El municipio más rico de España, villas premium La Zagaleta (campos golf), gran demanda toldos motorizados grandes."
      isCoreZone={false}
    />
  );
}